import { BaseApi } from '../../../api/apiBase';
import type { SurveyDraft } from '../../types/surveys/publicSurvey.types';

class DraftsApi extends BaseApi {
  constructor() {
    super('/api/portal');
  }

  async createDraft(eventSlug: string, surveySlug: string): Promise<SurveyDraft> {
    return this.post<SurveyDraft>(`/events/${eventSlug}/surveys/${surveySlug}/drafts`, {});
  }

  async updateDraft(eventSlug: string, surveySlug: string, authToken: string, updates: any): Promise<SurveyDraft> {
    return this.put<SurveyDraft>(`/events/${eventSlug}/surveys/${surveySlug}/drafts/${authToken}`, updates);
  }

  async getDraft(eventSlug: string, surveySlug: string, authToken: string): Promise<SurveyDraft> {
    return this.get<SurveyDraft>(`/events/${eventSlug}/surveys/${surveySlug}/drafts/${authToken}`);
  }
}

export const draftsApi = new DraftsApi();